export default __webpack_public_path__ + "static/media/blackbook-sidebar-icon.c352d6e8.svg";